import { all, put, select, takeLatest, call } from 'redux-saga/effects';

import api from '../../services/analytic_api';
import {
  createSession,
  endSession,
  navigationUrl,
  updateSession,
  negotiation,
  payment,
  setErrorAction,
  setPageView,
} from './actions';
import { setNegotiationState } from '../negotiation/actions';

function* createSessionSaga(action: ReturnType<typeof createSession.request>) {
  try {
    const data: string = yield call(api.createSession, action.payload);
    if (data) {
      yield call(api.setToken, data);
      yield put(createSession.success(data));
    }
  } catch (err) {
    yield put(createSession.failure(err.message));
  }
}

function* navigationUrlSaga(action: ReturnType<typeof navigationUrl.request>) {
  try {
    const data: GQL.INavigationResponse = yield call(
      api.navigationUrl,
      action.payload
    );
    yield put(navigationUrl.success(data));
    yield put(setPageView.success(action.payload.action));
  } catch (err) {
    yield put(navigationUrl.failure(err.message));
  }
}

function* negotiationSaga(action: ReturnType<typeof negotiation.request>) {
  try {
    yield call(api.setNegotiation, action.payload);
    yield put(setNegotiationState.success(action.payload));
  } catch (err) {
    yield put(negotiation.failure(err.message));
  }
}

function* updateSessionSaga(action: ReturnType<typeof updateSession.request>) {
  try {
    const cpf = yield select((state: ApplicationState) => state.auth.cpf);
    const data: string = yield call(api.updateSession, cpf);
    if (data) {
      yield put(updateSession.success(data));
    }
  } catch (err) {
    yield put(updateSession.failure(err.message));
  }
}

function* endSessionSaga(action: ReturnType<typeof endSession.request>) {
  try {
    yield call(api.endSession);
  } catch (err) {
    yield put(endSession.failure(err.message));
  }
}

function* paymentSaga(action: ReturnType<typeof payment.request>) {
  try {
    yield call(api.setPayment, action.payload);
  } catch (err) {
    yield put(payment.failure(err.message));
  }
}

function* setErrorSaga(action: ReturnType<typeof setErrorAction.request>) {
  try {
    action.payload.options.errorMessage = action.payload.options.errorMessage.replace(
      /\"/g,
      "'"
    );
    action.payload.options.errorMessage = action.payload.options.errorMessage.replace(
      /\n/g,
      ' '
    );
    yield call(api.setError, action.payload);
  } catch (err) {
    yield put(setErrorAction.failure(err.message));
  }
}

export default all([
  takeLatest(createSession.request, createSessionSaga),
  takeLatest(navigationUrl.request, navigationUrlSaga),
  takeLatest(negotiation.request, negotiationSaga),
  takeLatest(updateSession.request, updateSessionSaga),
  takeLatest(endSession.request, endSessionSaga),
  takeLatest(payment.request, paymentSaga),
  takeLatest(setErrorAction.request, setErrorSaga),
]);
